import { TextSelection } from 'prosemirror-state'
import { TEXT_STYLES } from '../constants'
import { preserveSelection } from '../utils/selection'
import { Command } from './types'

export const setBlockType = (textStyleKey: keyof typeof TEXT_STYLES): Command => {
  return (state, dispatch) => {
    const {
      selection,
      selection: { ranges },
      tr,
    } = state
    const textStyle = TEXT_STYLES[textStyleKey]
    let willDispatch = false

    for (let {
      $from: { pos: from },
      $to: { pos: to },
    } of ranges) {
      state.doc.nodesBetween(from, to, (node, pos, parent) => {
        if (node.type.groups.includes('textWrap')) {
          const selectionEndsAtNodeStart = pos + 1 === to
          if (
            (selection instanceof TextSelection && (selection as TextSelection).$cursor) ||
            !selectionEndsAtNodeStart
          ) {
            willDispatch = true
            tr.setNodeMarkup(pos, textStyle.type, { ...node.attrs, ...textStyle.attrs }, node.marks)
          }
        }
      })
    }
    preserveSelection(tr, state)
    willDispatch && dispatch?.(tr)
    return willDispatch
  }
}
